import { translate } from "app/filters/i18nFilter";
import NewAssetIconButtonTracked from "app/pages/sales-intelligence/pages/home/containers/NewAssetButton/NewAssetIconButtonTracked";
import TutorialViewTracked from "app/pages/sales-intelligence/pages/home/containers/TutorialView/TutorialViewTracked";
import { PlainTooltip } from "@similarweb/ui-components";
import { StyledButtonsContainer } from "../../components/styles";
import type { ViewModelMetadata } from "../../types/models";
import { MAX_WATCH_LIST_TOOLTIP_WIDTH } from "app/pages/sales-intelligence/pages/home/utils/const";

type Props = {
    metadata: ViewModelMetadata;
    onNewSearch(): void;
};

const SavedSearchesCardHeaderActions = ({ metadata, onNewSearch }: Props) => {
    return (
        <StyledButtonsContainer>
            <NewAssetIconButtonTracked
                metadata={metadata}
                onClick={onNewSearch}
            >
                {translate("si.pages.home.card.saved-searches.action.new-search")}
            </NewAssetIconButtonTracked>

            <PlainTooltip
                tooltipContent={translate("si.pages.home.card.tooltip.watch_tutorial")}
                placement="top"
                maxWidth={MAX_WATCH_LIST_TOOLTIP_WIDTH}
            >
                <div>
                    <TutorialViewTracked
                        metadata={metadata}
                        stateId="salesIntelligence-home-savedSearches"
                    />
                </div>
            </PlainTooltip>
        </StyledButtonsContainer>
    );
};

export default SavedSearchesCardHeaderActions;
